// MIT License - Copyright (c) 2026 Doug McNall
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { ToastProvider } from './context/ToastContext';
import { AccessControlProvider } from './hooks/useAccessControl';
import AdminAuthGuard from './components/AdminAuthGuard';
import AdminLayout from './components/AdminLayout';
import TabManager from './components/TabManager';
import './styles/theme.css';

function App() {
  return (
    <Router>
      <ThemeProvider>
        <ToastProvider>
          <AuthProvider>
            <AccessControlProvider>
              <AdminAuthGuard>
                <AdminLayout>
                  <TabManager />
                </AdminLayout>
              </AdminAuthGuard>
            </AccessControlProvider>
          </AuthProvider>
        </ToastProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;
